import { api } from './apiClient';

export interface CompanySettings {
  companyName: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  phone: string;
  email: string;
  gstin: string;
  bankName: string;
  bankAccountNumber: string;
  bankIfscCode: string;
  bankBranch: string;
}

export interface UserPreferences {
  language: string;
  dateFormat: string;
  currency: string;
  notifications: string;
  theme: string;
  [key: string]: string;
}

export const settingsService = {
  getCompanySettings: () =>
    api.get<{ settings: CompanySettings }>('/settings/company'),

  updateCompanySettings: (data: Partial<CompanySettings>) =>
    api.put('/settings/company', data),

  getPreferences: () =>
    api.get<{ preferences: UserPreferences }>('/settings/preferences'),

  updatePreferences: (data: Partial<UserPreferences>) =>
    api.put('/settings/preferences', data),
};
